import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from 'src/app/_services/Customer/customer.service';
import { NewBillItem } from 'src/app/Entites/NewBillItem/NewBillItem';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { ToastrService } from 'ngx-toastr';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { float } from 'html2canvas/dist/types/css/property-descriptors/float';
import { ProductItemService } from 'src/app/_services/productItem/product-item.service';
import { RentbillService } from 'src/app/_services/rentbill/rentbill.service';

import { NewPayemnts } from 'src/app/Entites/Payments/Payments';
import { ConfirmComponent } from '../../confirm/confirm';
import { SimpleModalService } from 'ngx-simple-modal';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
@Component({
  selector: 'app-rentinvoice',
  templateUrl: './rentinvoice.component.html',
  styleUrls: ['./rentinvoice.component.css'],
  providers: [Dateconfig, CustomLoaderCComponent]
})
export class RentinvoiceComponent implements OnInit {
  @ViewChild('ng-select') ngSelect;
  @BlockUI('singleSelect') blockUISingleSelect: NgBlockUI;
  @BlockUI('multipleSelect') blockUIMultipleSelect: NgBlockUI;
  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @Output() closeModalEvent = new EventEmitter<boolean>();

  /**
     *
     * @param NgbModal      modal
     */
  public customerarray;
  NewBillItem = new NewBillItem()
  public model: any = { rentBillDeposit: 0};
  model1: any = {};
  rows1: any;
  rows: any;

  temp = [];
  public billItems = [];
  public breadcrumb: any;
  options = {
    close: false,
    expand: true,
    minimize: true,
    reload: false
  };
  loading = false;
  submitted = false;
  f: NgForm;
  f1: NgForm;

  customermodel: any = {}
  idBillMatser: string;
  showcustomer: boolean = false;
  booleanvalue: boolean = false;
  public showCustomerdetails: boolean = false;
  public isgst: boolean = false;
  public maxdate;
  public lstitem = [];
  public customer: any = {}
  public isEnabled;
  NewPayemnts = new NewPayemnts();
  public paymentsarray = [];
  MasterData;
  mastergst;
  public idLoggedInEmployee: number;

  constructor(
    private CustomerService: CustomerService,
    private router: ActivatedRoute,
    private routernav: Router,
    private modalpop: NgbModal,
    private dateconfig: Dateconfig,
    private spinner: CustomLoaderCComponent,
    private toastrService: ToastrService,
    private productItemService: ProductItemService,
    private rentbillService: RentbillService,
    private simpleModalService: SimpleModalService
  ) { 
      this.idLoggedInEmployee = Number(localStorage.getItem(LocalStorageConstants.ID));
  }

  ngOnInit() {

    this.MasterData = JSON.parse(localStorage.getItem(LocalStorageConstants.MASTER_DATA));
    this.mastergst = this.MasterData.filter(function (d) {
      return d.master_Code == "GST";
    });
    this.spinner.showSpinner();
    this.maxdate = this.dateconfig.getcurrentdate();

    this.CustomerService.GetAllCustomer().subscribe(Response => {
      if (Response != null) {
        this.rows = Response;
        this.customerarray = this.rows;
      }
      else {
        this.customerarray = [];
      }
      this.spinner.hideSpinner();
    });

    this.idBillMatser = this.router.snapshot.queryParamMap.get('Id');
    this.customer = this.router.snapshot.queryParamMap.get('customer');
    if (this.customer != null) {
    }

    this.idBillMatser = atob(this.idBillMatser);

    if (Number(this.idBillMatser) > 0) {
      document.title = 'Update Rent/Repair Bill';
      this.showcustomer = true;
      this.showCustomerdetails = true;
      this.booleanvalue = true;
      this.spinner.showSpinner();
      this.rentbillService.GetBillById(Number(this.idBillMatser)).subscribe(Response => {
        this.model = Response;
        this.model.billDate = this.dateconfig.getshortdate(this.model.billDate);
        this.breadcrumb = {
          'mainlabel': 'Update Rent/Repair Bill - ' + this.model.displayBillNumber
        };

        if (Response.listPayment == null) {
          this.AddFormPaymentsarray();
        }
        else {
          this.paymentsarray = Response.listPayment;
          for (var i = 0; i < this.paymentsarray.length; i++) {
            this.paymentsarray[i].paymentDate = this.dateconfig.getshortdate(this.paymentsarray[i].paymentDate);
          }
        }

        this.billItems = Response.listRentBillItems;
        this.CustomerService.GetById(Number(Response.idCustomer)).subscribe(Response => {
          this.model.selectcustomer = Response;
          this.bindformcustomer(this.model.selectcustomer);
          this.spinner.hideSpinner();
        });
      });
    }
    else {
      this.NewBillItem = new NewBillItem();
      this.NewBillItem.productGST = Number(this.mastergst[0].master_Description);
      this.billItems.push(this.NewBillItem);
      this.AddFormPaymentsarray();
      this.NewPayemnts.paymentDate = this.dateconfig.getcurrentdate();
      this.model.billDate = this.dateconfig.getcurrentdate();
      this.maxdate = this.dateconfig.getcurrentdate();
      this.breadcrumb = {
        'mainlabel': 'Add Rent Bill',
      };
    }
  }

  bindformcustomer(selectcustomerdata) {
    this.showcustomer = false;
    if (selectcustomerdata == null) {
      this.cancel();
    }
    else {
      this.customermodel = selectcustomerdata;
      this.model.selectcustomer = selectcustomerdata;
      this.showcustomer = true;
    }
  }

  AddForm() {
    this.NewBillItem = new NewBillItem()
    this.NewBillItem.productGST = Number(this.mastergst[0].master_Description);
    this.billItems.push(this.NewBillItem);
  }

  RemoveForm(index) {
    this.billItems[index].operationState = "d";
    this.calculatetotal();
  }

  cancel() {
    if (Number(this.idBillMatser) > 0) {
      this.routernav.navigate(['/rentinvoice/all']);
    }
    this.showcustomer = false;
    this.showCustomerdetails = false;
    this.model = { rentBillDeposit : 0};
    this.customermodel = {};
    this.model.billDate = this.dateconfig.getcurrentdate();
    this.modalpop.dismissAll();
    this.billItems.slice(0, this.billItems.length);
  }

  GstExcluded() {
    if (this.model.billItemsGSTIsExcluded == undefined || !this.model.billItemsGSTIsExcluded) {
      this.isgst = true;
      for (var i = 0; i < this.billItems.length; i++) {
        this.billItems[i].billItemsItemGST = 0;
        this.billItems[i].operationState = "u";
      }
      this.calculatetotal();
    }
    else if (this.model.billItemsGSTIsExcluded) {
      this.isgst = false
      this.calculatetotal();
    }
  }

  calculateammounttotal(i) {
    this.billItems[i].productRate = 0;
    if (this.billItems[i].productQty && this.billItems[i].productTotalAmount) {
      this.billItems[i].productRate = this.billItems[i].productTotalAmount / this.billItems[i].productQty;
      var x = (this.billItems[i].productRate - (this.billItems[i].productRate * (100 / (100 + this.billItems[i].productGST))));
      this.billItems[i].productRate = this.billItems[i].productRate - Number(x);
      this.billItems[i].productRate = Number((this.billItems[i].productRate).toFixed(2));
      this.billItems[i].productToalGSTAmount = Number((Number(x) * this.billItems[i].productQty).toFixed(2));
      this.calculatetotal();
    }
  }

  public calculatetotal() {
    this.model.totalAmountIncGST = 0;
    for (var i = 0; i < this.billItems.length; i++) {
      if (this.billItems[i].productRate && this.billItems[i].productQty && this.billItems[i].operationState != "d") {
        this.billItems[i].productTotalAmount = this.billItems[i].productQty * this.billItems[i].productRate;
        var GST_Amount = (this.billItems[i].productTotalAmount * this.billItems[i].productGST) / 100;
        this.billItems[i].productTotalAmount = this.billItems[i].productTotalAmount + Number(GST_Amount);
        this.billItems[i].productTotalAmount = Number((this.billItems[i].productTotalAmount).toFixed(2));
        this.billItems[i].productToalGSTAmount = Number((GST_Amount).toFixed(2));
        this.model.totalAmountIncGST = this.model.totalAmountIncGST + this.billItems[i].productTotalAmount;
      }
    }
    this.model.totalAmountIncGST = Math.round(this.model.totalAmountIncGST);
  }

  CalculatTotalPaidAmount() {
    this.model.totalpaidAmount = 0;
    for (var i = 0; i < this.paymentsarray.length; i++) {
      if (this.paymentsarray[i].operationState != "d"
        && (this.paymentsarray[i].paidAmount != undefined
          || this.paymentsarray[i].paidAmount != 0)
      ) {
        this.model.totalpaidAmount = Number(this.model.totalpaidAmount) + Number(this.paymentsarray[i].paidAmount);
      }
    }
    this.CalculatBalanceAmount();
  }

  updateOperationStateForBillItem(i) {
    if (this.billItems[i].idBillItem != undefined) {
      this.billItems[i].operationState = "u"
    }
  }

  CalculatBalanceAmount() {
    this.model.balanceAmount = Math.round(this.model.totalAmountIncGST - this.model.totalpaidAmount);
  }

  validateBill() {
    var isValid = false;
    for (var i = 0; i < this.billItems.length; i++) {
      if (this.billItems[i].operationState != "d" &&
        (this.billItems[i].productDescription == '' || this.billItems[i].productDescription == undefined)) {
        isValid = false;
        return isValid;
      }
    }

    for (var i = 0; i < this.paymentsarray.length; i++) {
      if (this.paymentsarray[i].operationState != "d" &&
        (this.paymentsarray[i].payMode == '' && this.paymentsarray[i].paidAmount > 0)) {
        this.toastrService.warning("Plese select payment method", '', { timeOut: 2000, closeButton: true });
        isValid = false;
        return isValid;
      }
    }

    this.CalculatTotalPaidAmount();
    if (this.model.totalAmountIncGST < this.model.totalpaidAmount) {
      this.toastrService.error("Amount is greater than total.", '', { timeOut: 2000, closeButton: true });
      isValid = false;
    }

    if (this.model.billType.toString().toLowerCase() == 'rent') {
      // Rent deposit warning
      if (this.model.rentBillDeposit == undefined || this.model.rentBillDeposit <= 0) {
        this.simpleModalService.addModal(ConfirmComponent, {
          title: 'Confirmation',
          message: 'Are you sure to proceed without Rent Deposit ?'
        })
          .subscribe((isConfirmed) => {
            if (!isConfirmed) {
              isValid = false;
            }
          });
      }
    }

    return isValid;
  }

  saveBill(isValid: any) {
    for (var i = 0; i < this.billItems.length; i++) {
      if (this.billItems[i].operationState != "d" &&
        (this.billItems[i].productDescription == '' || this.billItems[i].productDescription == undefined)) {
        isValid = false;
        break;
      }
    }

    for (var i = 0; i < this.paymentsarray.length; i++) {
      if (this.paymentsarray[i].operationState != "d" &&
        (this.paymentsarray[i].payMode == '' && this.paymentsarray[i].paidAmount > 0)) {
        this.toastrService.warning("Plese select payment method", '', { timeOut: 2000, closeButton: true });
        isValid = false;
        break;
      }
    }

    this.CalculatTotalPaidAmount();
    if (this.model.totalAmountIncGST < this.model.totalpaidAmount) {
      this.toastrService.error("Amount is greater than total.", '', { timeOut: 2000, closeButton: true });
      isValid = false;
    }

    if (isValid) {
      if (this.model.billType.toString().toLowerCase() == 'repair') {
        this.model.accountNumber = '055163300004565';
        this.model.ifscCode = 'YESB0000551';
        this.model.branchName = 'Bund Garden';
        this.model.bankName = 'YES BANK';
      }
      else {
        this.model.accountNumber = '777705010808';
        this.model.ifscCode = 'ICIC0000581';
        this.model.branchName = 'Magarpatta';
        this.model.bankName = 'ICICI BANK';
      }

      if (this.model.billType.toString().toLowerCase() == 'rent' && this.model.rentBillDeposit == undefined || this.model.rentBillDeposit <= 0) {
        // Rent deposit warning
        this.simpleModalService.addModal(ConfirmComponent, {
          title: 'Confirmation',
          message: 'Are you sure to proceed without Rent Deposit ?'
        })
          .subscribe((isConfirmed) => {
            if (!isConfirmed) {
              isValid = false;
              return;
            }
            else {
              this.SaveBillDetails();
            }
          });
      }
      else {
        this.SaveBillDetails();
      }
    }
  }

  SaveBillDetails() {
    if (Number(this.idBillMatser) < 0 || this.idBillMatser == "ée" || this.idBillMatser == null) {
      for (var i = 0; i < this.billItems.length; i++) {
        if (this.billItems[i].operationState == "d") {
          this.billItems.splice(i, 1);
        }
      }
      this.model.listPayment = this.paymentsarray;
      this.model.listRentBillItems = this.billItems;
      this.model.idCustomer = this.model.selectcustomer.idCustomer;
      this.model.createdBy = this.idLoggedInEmployee;
      this.model.rentBillDeposit = this.model.billType.toString().toLowerCase() == 'rent' ? Number(this.model.rentBillDeposit) : 0;
      this.spinner.showSpinner();
      console.log(this.model)
      this.rentbillService.saveBill(this.model).subscribe(
        (res: any) => {
          if (res.result >= 1) {
            this.spinner.hideSpinner();
            this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
            window.open('/viewrentbill?Id=' + btoa(res.idBillmaster) + '', '_blank');
            //    this.cancel();
            this.routernav.navigate(['/rentinvoice/all']);
          }
          else {
            this.spinner.hideSpinner();
            this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
          }
        },
        err => {
          this.spinner.hideSpinner();
          this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
        }
      )
    }
    else if (Number(this.idBillMatser) > 0) {
      this.model.rentBillDeposit = this.model.billType.toString().toLowerCase() == 'rent' ? Number(this.model.rentBillDeposit) : 0;
      for (var i = 0; i < this.billItems.length; i++) {
        if (this.billItems[i].idBillItem == undefined && this.billItems[i].operationState == "d") {
          this.billItems.splice(i, 1);
        }
      }
      for (var i = 0; i < this.paymentsarray.length; i++) {
        if (this.paymentsarray[i].operationState == "d" && this.paymentsarray[i].idPayment == undefined) {
          this.paymentsarray.splice(i, 1);
        }
      }
      this.model.listPayment = this.paymentsarray;
      this.model.listRentBillItems = this.billItems;
      this.model.modifiedBy = this.idLoggedInEmployee;
      this.model.idCustomer = this.model.selectcustomer.idCustomer;
      this.spinner.showSpinner();
      this.rentbillService.updateBill(this.model).subscribe(
        (res: any) => {
          console.log(res);
          if (res.result == 1) {
            this.spinner.hideSpinner();
            this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
            window.open('/viewrentbill?Id=' + btoa(this.idBillMatser) + '', '_blank');
            //   this.cancel();
            this.routernav.navigate(['/rentinvoice/all']);
          }
          else {
            this.spinner.hideSpinner();
            this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
          }
        },
        err => {
          this.spinner.hideSpinner();
          this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
        }
      )
    }
  }

  AddFormPaymentsarray() {
    this.NewPayemnts = new NewPayemnts()
    this.NewPayemnts.paymentDate = this.dateconfig.getcurrentdate();
    this.NewPayemnts.paidAmount = 0;
    this.paymentsarray.push(this.NewPayemnts);
    window.setTimeout(function () {
    }, 0);
  }

  RemoveFormPaymentsarray(i) {
    this.paymentsarray[i].operationState = "d";
    // this.CalculatTotalPaidAmount();
  }

  SaveCustomer(isValid: any) {
    if (isValid) {
      if (this.model.idCustomer == undefined) {
        this.spinner.showSpinner();
        this.model.createdBy = this.idLoggedInEmployee;
        this.CustomerService.savecustomer(this.model).subscribe(
          (res: any) => {
            if (res.result == 1) {
              this.spinner.showSpinner();
              this.cancel();
              this.customerarray.push(res);
              this.bindformcustomer(res);
              this.model.selectcustomer = res;
              this.customerarray = [this.customerarray];
              this.spinner.hideSpinner();
              this.toastrService.success(res.userMessage, '', { timeOut: 2000, closeButton: true });
            }
            else {
              this.spinner.hideSpinner();
              this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
            }
          },
          err => {
            this.spinner.hideSpinner();
            this.toastrService.error('server down', '', { timeOut: 3000, closeButton: true });
          }
        )
      }
    }
  }

  addcustomer(model: any) {
    this.model.action = "Add Customer"
    this.modalpop.open(this.modalContent, {
      size: 'lg', backdrop: 'static',
      keyboard: false
    });
  }

  updateOperationState(i) {
    if (this.billItems[i].idBillItem != undefined) {
      this.billItems[i].operationState = "u"
    }
  }

  updateOperationStateForpayment(i) {
    if (this.paymentsarray[i].idPayment != undefined) {
      this.paymentsarray[i].operationState = "u";
    }
    this.CalculatTotalPaidAmount();
  }

  onScan(index) {
    this.spinner.showSpinner();
    this.productItemService.GetProductItemByBarCode(this.billItems[index].billItemsItem).subscribe(Response => {
      if (Response != null) {
        this.billItems[index].billItemsItem = Response.productItemDescription;
        this.billItems[index].billItemsItemGST = Response.productGST;
        this.billItems[index].billItemsItemHSNSAC = Response.productHSN;
        this.billItems[index].billItemsItemQuantity = 1;
        this.billItems[index].billItemsAmmount = 1 * Response.productItemPrice;
        this.calculateammounttotal(index)
        this.calculatetotal();
      }
      else {
        this.toastrService.warning("Bar Code Not", '', { timeOut: 2000, closeButton: true });
      }

      this.spinner.hideSpinner();
    });
  }
}
